import i18next from 'i18next'
import {PayByLinkStatus} from '@/constants'
import {SelectItem} from '@/components/dumb/Select'

const statusKeys = [
    PayByLinkStatus.all,
    PayByLinkStatus.active,
    PayByLinkStatus.expired,
    PayByLinkStatus.paid,
    PayByLinkStatus.cancelled,
    PayByLinkStatus.attempted,
    PayByLinkStatus.viewed
] as const

export const statuses = () =>
    statusKeys.map((value) => ({
        label: i18next.t(`enums:payByLinkStatus.${value}`),
        value
    })) as SelectItem[]
